import OrdersScreenComponent from './OrdersScreenComponent';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { select } from '../../../store/store';
import { iRootDispatch, iRootState } from '../../../store/store';
import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslationProps } from 'react-i18next';
import { connect } from 'react-redux';
import { LogisticUnitSimpleTextData } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import enOrderState from '../../../api/enums/enOrderState';
import { RouteLocationModelSimpleTextData } from 'fulogics-ui-web/dist/layout/components/route-location-model-simple-text/RouteLocationModelSimpleText';
import { UserModelSimpleTextData } from 'fulogics-ui-web/dist/layout/components/user-model-simple-text/UserModelSimpleText';
import { COSOrdersStore } from '../../../store/models/COSOrdersModel';

export type TruckKindModel = {
    brand: string;
    model: string;
};

export type TruckModel = {
    symbol?: string;
    truckKind?: TruckKindModel;
};

export type OrdersGridItemData = {
    id?: number;
    createdDate?: Date;
    //
    draftCloseDeadline?: Date; // przekazanie do realizacji
    //
    state?: enOrderState;
    currentEditing?: {
        editingBy?: UserModelSimpleTextData;
        editingDeadline?: Date; // chyba nie wykorzystywane
    };
    //
    wmsExternalId?: string;
    wmsOrderIds?: string;
    tmsExternalId?: string;
    editedBy?: {
        organization?: LogisticUnitSimpleTextData;
        user?: UserModelSimpleTextData;
    }[];
    //
    transportOperator?: {
        operatingOrganization?: LogisticUnitSimpleTextData;
        driver?: UserModelSimpleTextData;
    };
    forwardSteps?: {
        id?: string;
        //
        filledTrailerCapacity?: number;
        maxTrailerCapacity?: number;
        //
        firstUnload?: {
            plannedStartDate?: Date;
        };
        items?: {
            location?: RouteLocationModelSimpleTextData;
        }[];
    };
    returnSteps?: {
        id?: string;
        //
        filledTrailerCapacity?: number;
        maxTrailerCapacity?: number;
        //
        items?: {
            location?: RouteLocationModelSimpleTextData;
        }[];
    };
};

export const OrdersGridItemDataKeys = [];

export type OrdersScreenStateProps = {
    createOrdersDataSource: () => DataSourceOptions | undefined;
    currentUserId?: string | number;
} & WithTranslationProps;

interface OrdersScreenDispatchProps {}

const selection = () => select((_models) => ({}));

export type OrderDetailsDrawerContextType = {
    orderItem?: OrdersGridItemData;
    currentUserId?: string | number;
    removeItem?: (key: any) => Promise<any>;
};

const mapStateToProps = (
    state: iRootState,
    ownProps: RouteComponentProps<{}> & WithTranslationProps
): OrdersScreenStateProps => ({
    createOrdersDataSource: () => {
        return {
            store: COSOrdersStore,
            //
            select: OrdersGridItemDataKeys,
        } as DataSourceOptions;
    },
    currentUserId: state?.Identity?.userProfile?.id,
    //
    ...selection()(state),
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrdersScreenDispatchProps) =>
    ({
        //
        ..._ownDispatch,
    } as OrdersScreenDispatchProps);

type connectedProps = OrdersScreenStateProps & ReturnType<typeof mapDispatch>;
export type OrdersScreenProps = connectedProps;

export const OrdersScreen = withTranslation()(
    connect(mapStateToProps, mapDispatch as any)(OrdersScreenComponent)
);
